import configVars from "@/config/config_vars";
let appBaseUrl = configVars.appBaseUrl;

import axios from "axios";

//import querystring from "querystring";


/**
 * ============================
 * @param {*} param0
 * @param {*} params
 * @description Create Order
 * ============================
 */
var createOxxoOrder = (params) => {
  let searchEventQuery = `${appBaseUrl}ox/create_order`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${searchEventQuery}`, params)

}

/**
 * ============================
 * @param {*} param0
 * @param {*} params
 * @description Create Order
 * ============================
 */
var createOxxoOrderWithoutCharges = (params) => {
  let searchEventQuery = `${appBaseUrl}ox/create_order_without_charges`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${searchEventQuery}`, params)

}

var createOxxoOrderWithoutChargesFrom = (order_oxxo_id) => {
  let searchEventQuery = `${appBaseUrl}ox/create_order_without_charges_from/${order_oxxo_id}`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${searchEventQuery}`)

}






/**
 * ============================
 * @param {*} param0
 * @param {*} params
 * @description Get Oxxo Order
 * ============================
 */
var getOxxoOrder = (reference) => {
  let searchEventQuery = `${appBaseUrl}ox/order?reference=${reference}`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.get(`${searchEventQuery}`)

}


/**
 * ============================
 * @param {*} param0
 * @param {*} params
 * @description Get Oxxo Order
 * ============================
 */
var getOxxoOrderById = (oxxoIdOrder) => {
  let searchEventQuery = `${appBaseUrl}ox/order_oxxo?oxxoIdOrder=${oxxoIdOrder}`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.get(`${searchEventQuery}`)

}






var scheduleOxxoNot = (order_usuario) => {
  let notificacionURL = `${appBaseUrl}nt/schedule-oxxo-not`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${notificacionURL}`, order_usuario)

}


var getCurrency = () => {
  let searchEventQuery = `${appBaseUrl}ox/currency`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.get(`${searchEventQuery}`)

}

var activateOrder=(order)=>{
  let notificacionURL = `${appBaseUrl}ox/activate_order`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${notificacionURL}`, order)

}

let isThereBlokingOrders =(ticket_group_id)=>{
  let notificacionURL = `${appBaseUrl}ox/bloking_orders/${ticket_group_id}`;
  let instance = axios.create();
  instance.defaults.headers.common = {};
  return   instance.post(`${notificacionURL}`)

}





export default {
   createOxxoOrder,
   getOxxoOrder,
   scheduleOxxoNot,
   getCurrency,
   createOxxoOrderWithoutCharges,
   getOxxoOrderById,
   activateOrder,
   createOxxoOrderWithoutChargesFrom,
   isThereBlokingOrders
}
